/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_History_Note_Deleted_BadgeInputs */

const en_case_history_note_deleted_badge = /** @type {(inputs: Case_History_Note_Deleted_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleted`)
};

const pt_br2_case_history_note_deleted_badge = /** @type {(inputs: Case_History_Note_Deleted_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluída`)
};

/**
* | output |
* | --- |
* | "Deleted" |
*
* @param {Case_History_Note_Deleted_BadgeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_history_note_deleted_badge = /** @type {((inputs?: Case_History_Note_Deleted_BadgeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_History_Note_Deleted_BadgeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_history_note_deleted_badge(inputs)
	return pt_br2_case_history_note_deleted_badge(inputs)
});